<template>
    <div class="container">
        <div class="block_static"
        :style="{

            background:color!='' ? color : ''

        }" v-for="(bloc, i) in Block"
                :key="bloc.id">

                <div class="row" style="display: flex;align-items: center;" >
                    <div class="col-sm-6">
                        <div class="header_block_static"
                        :style="{

                            color:bloc.titulo!='' ? bloc.titulo : ''

                        }"
                                >

                                <span v-html="bloc.titulo" ></span>

                            <div class="descripcion_block_static"

                            :style="{

                            color:bloc.descripcion!='' ? bloc.descripcion : ''

                            }"

                             v-html="bloc.descripcion"></div>
                            <br>
                             <div v-if="bloc.link_boton != '' && bloc.texto_boton != ''"
                               >
                                <a
                                    class="btn banner-button btn-static"
                                    :href="bloc.link_boton"
                                    v-if="bloc.link_boton!='#registro' && bloc.link_boton!='#login'">
                                    {{ bloc.texto_boton }}
                                </a>
                                 <a
                                    class="btn banner-button btn-static"
                                    href="#" @click="toggleRegistroModal(true)"
                                    v-if="bloc.link_boton=='#registro'">
                                    {{ bloc.texto_boton }}
                                </a>
                                 <a
                                    class="btn banner-button btn-static"
                                    href="#" @click="toggleLoginModal(true)"
                                    v-if="bloc.link_boton=='#login'">
                                    {{ bloc.texto_boton }}
                                </a>
                                <span v-if="bloc.precio && bloc.precio!='0'"
                                    class="banner-precio carousel-precios">
                                    {{ bloc.precio }}
                                </span>
                            </div>
				        </div>

                    </div>
                    <div class="col-sm-6 ocultar-movil">


                            <div class="container"
                    :class="{
                        'container-has-video': bloc.isLoaded && bloc.isPlayerVisible,
                        'banner-content-hidden': !bloc.isHovered
                    }">
                    <div
                        class="container-video"
                        :id="'container-video-' + bloc.id"
                        :style="{
                            backgroundImage: bloc.foto_principal == '' ? 'url(' + (bloc.foto_principal.includes('/fl_lossy/')) ? bloc.foto_principal.replace('http:', 'https:') : bloc.foto_principal.replace('upload', 'upload/fl_lossy').replace('http:', 'https:')  + ')' : 'none'
                        }"

                        @mouseover="toggleHover(bloc, true)"
                        @mouseleave="toggleHover(bloc, false, 1000)">

                        <img v-if="bloc.banners_videos.length<=0"
                            :src="(bloc.foto_principal.includes('/fl_lossy/')) ? bloc.foto_principal.replace('http:', 'https:') : bloc.foto_principal.replace('upload', 'upload/fl_lossy').replace('http:', 'https:') " />

                    <div v-else>
                        <div :id="'home-banner-video-' + bloc.id"
                            class="home-banner-video"
                            :class="{
                                'banner-content-hidden': !bloc.isPlayerVisible
                            }"

                            @click="pauseVideoBlock((i+100))"></div>
                    </div>

                         <div v-if="bloc.banners_videos" class="banner-content-video-movil">

                            <div class="banner-video-controls mostrar-movil"
                             style="
                                    margin: auto;
                                    padding-bottom: 80px;"
                                v-if="bloc.playerIndex !== false && bloc.isLoaded">
                                <button class="bg-trans"
                                    @click="pauseVideoBlock((i+100), false, $event)">
                                    <img :src="bloc.isPlaying ? require('@/assets/images/pause.svg') : require('@/assets/images/play.svg')"
                                        class="banner-video-play"
                                        :alt="bloc.isPlaying ? 'Pausar' : 'Reproducir'">
                                </button>
                                <button class="bg-trans"
                                    @click="replay(bloc)">
                                    <img :src="require('@/assets/images/reload.svg')"
                                        class="banner-video-replay"
                                        alt="Reiniciar">
                                </button>
                                <button class="bg-trans"
                                    @click="toggleMute(bloc)">
                                    <img :src="!bloc.isMuted ? require('@/assets/images/volume-up.svg') : require('@/assets/images/volume-off.svg')"
                                        class="banner-video-mute"
                                        :alt="bloc.isMuted ? 'Escuchar' : 'Silenciar'">
                                </button>
                            </div>

                        </div>

                        <div  v-if="bloc.banners_videos" class="banner-content-home">
                            <div class="banner-video-controls ocultar-movil"
                                v-if="bloc.playerIndex !== false && bloc.isLoaded">
                                <button class="bg-trans"
                                    @click="pauseVideoBlock((i+100), false, $event)">
                                    <img :src="bloc.isPlaying ? require('@/assets/images/pause.svg') : require('@/assets/images/play.svg')"
                                        class="banner-video-play"
                                        :alt="bloc.isPlaying ? 'Pausar' : 'Reproducir'">
                                </button>
                                <button class="bg-trans"
                                    @click="replay(bloc)">
                                    <img :src="require('@/assets/images/reload.svg')"
                                        class="banner-video-replay"
                                        alt="Reiniciar">
                                </button>
                                <button class="bg-trans"
                                    @click="toggleMute(bloc)">
                                    <img :src="!bloc.isMuted ? require('@/assets/images/volume-up.svg') : require('@/assets/images/volume-off.svg')"
                                        class="banner-video-mute"
                                        :alt="bloc.isMuted ? 'Escuchar' : 'Silenciar'">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                    </div>

                </div>

        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import {
	getCategoriaDeProducto,
    getProductoDeCategoria,
    eventKlaviyo
} from "../utilities/data";
import { wait } from "../utilities/util";

export default {
    name: "BlockStatic",
	props: ["destacado","color","titulo","descripcion"],
	data() {
		return {
			Block: [],
			videosLoadedBlock: false,
			playerRetryCountBlock: 0
		};
	},
	watch: {
		isPortalReady(val, old) {

			if (val && !old && this.videosLoadedBlock) {
				this.loadBlock();
			}
		}
	},
	computed: {
		...mapState(["portal", "isPortalReady"])
	},
	methods: {
        toggleLoginModal(toggle) {
			this.$store.commit("togglePortalLoginModal", toggle);
		},
		toggleRegistroModal(toggle) {
			this.$store.commit("togglePortalRegistroModal", toggle);
		},
		/**
		 * Click en un link del banner.
		 */
		linkBanner(link) {
			if (link != "") {
				if (link.substring(0, 1) == "/") {
					this.$router.push({
						path: link
					});
				} else {
					window.location = link;
				}
			}
		},
		/**
		 * Carga un jwplayer por cada banner que tenga video.
		 */
		loadPlayer(banner) {
			// Esperar que el player este disponible
			if (
				typeof window.jwplayer === "undefined" ||
				document.querySelector("#home-banner-video-" + banner.id) ==
					null
			) {
				if (this.playerRetryCount < 10) {
					this.playerRetryCount++;
					return wait(() => {
						this.loadPlayer(banner);
					}, 900);
				} else if (this.contadorWait == 10) {
					console.log("ERROR AL CARGAR SCRIPT");
				}
			}

			this.$api
				.getPlayerEmbed("media", banner.banners_videos[0].video)
				.then(response => {
					let player = JSON.parse(response.data.player);
					if ("message" in player) return false;

					let sources = player[0].playlist[0].sources;
					// Buscar el tamaño más grande para calcular el alto.
					let ref = sources.reduce(
						(prev, item) => {
							if (
								item.hasOwnProperty("width") &&
								item.hasOwnProperty("height")
							)
								if (item.width > prev.width) return item;

							return prev;
						},
						{
							width: 0,
							height: 0
						}
					);

					let videoSize = this.getVideoSize(banner, ref);

					let jwplayer = window
						.jwplayer("home-banner-video-" + banner.id)
						.setup({
							file: sources[0].file,
							// width: videoSize.width,
							// height: videoSize.height,
							width: "100%",
							height: "16:9",
							mute: false,
							volume: 30
						})
						.setControls(false)
						.on("ready", e => {
							banner.isLoaded = true;
							banner.isPlayerVisible = true;
							if (banner.isPlaying) jwplayer.play();
							banner.isPlaying = true;
							banner.isMuted = jwplayer.getMute();
						})
						.on("play", () => {
							banner.isPlaying = true;
							banner.isPlayerVisible = true;
						})
						.on("pause", () => {
							banner.isPlaying = false;
							banner.isHovered = true;
						})
						.on("complete", () => {
							banner.isHovered = true;
							banner.isPlayerVisible = false;
                            banner.isPlaying = false;
                            banner.isLoaded=true;
						});

					this.players[banner.playerIndex] = jwplayer;

					// Si es el primer video, reproducir.
					if (this.banners[0].id == banner.id) {
						setTimeout(() => {
							this.players[banner.playerIndex].play();
							banner.isPlaying = true;
						}, 500);
					}
				})
				.catch(error => console.log("ERROR EMBED HOME", error));
		},
		/**
		 * Pasa por los Block y agrega videos a la lista de players.
		 */
		loadBlock() {
			this.videosLoadedBlock = true;
			let playersCountBlock = 0;
			this.portal.banners
				.sort((a, b) => {
					if (a.posicion < b.posicion) return -1;
					if (a.posicion > b.posicion) return 1;
					return 0;
				})
				.forEach((banner, i) => {

                    if(banner.tipo=='2'

                    && (banner.destacado_header==1 && this.destacado=="home")
                    || (banner.destacado_body==1 && this.destacado=="categoria")
                    || (banner.destacado_footer==1 && this.destacado=="checkout")

                    ){

                        if (
                            typeof banner.banners_videos !== "undefined" &&
                            banner.banners_videos.length > 0
                        ) {
                            this.Block.push({
                                ...banner,
                                playerIndex: Number(playersCountBlock+100),
                                isLoaded: false,
                                isPlaying: false,
                                isHovered: true,
                                isPlayerVisible: false,
                                isMuted: true
                            });
                            let index = this.Block.length - 1;
                            this.$nextTick(() => {
                                this.loadPlayer(this.Block[index]);
                            });
                            playersCountBlock++;
                        } else {
                            this.Block.push({
                                ...banner,
                                playerIndex: false,
                                isLoaded: false,
                                isPlaying: false,
                                isHovered: true
                            });
                        }

                    }
				});
		},
		/**
		 * Reproducir el video si no se está reproduciendo, mostrar el título y ocultarlo a los 3 segundos.
		 */
		checkVideoPlayBlock(current, next) {
             current=current-100;
			if (
				this.Block[current].playerIndex !== false &&
				this.players[this.Block[current].playerIndex].getState() ==
					"playing"
			)
				this.pauseVideoBlock(current);

			let banner = this.Block[next];
			banner.isHovered = true;
			if (banner.playerIndex !== false) {
				if (banner.isLoaded) {
					this.players[banner.playerIndex].play();
					wait(() => {
						banner.isHovered = false;
					}, 3000);
				} else {
					banner.isPlaying = true;
				}
			}
		},
		/**
		 * Pausa (o reanuda) video.
		 */
		pauseVideoBlock(index, tap, $event) {
            index=index-100;
			console.log("pausing", index, tap, $event);
			if (this.Block[index].playerIndex !== false) {
				let player = this.players[this.Block[index].playerIndex];
				if (player.getState() == "playing") player.pause();
				if (["idle", "paused"].includes(player.getState())) {
					player.play();
					this.$set(this.Block, "isPlaying", true);
					this.$set(this.Block, "isPlayerVisible", true);
					if (tap) {
						setTimeout(() => {
							this.$set(this.Block, "isHovered", false);
						}, 1000);
					}
				}
			}
		},
		/**
		 * Muestra / oculta info del video.
		 */
		toggleHover(banner, toggle, delay) {
			// Ignorar si no tiene video
			if (banner.playerIndex !== false)
				setTimeout(() => {
					banner.isHovered = toggle;
				}, delay || 0);
		},
		getVideoSize(banner, initialWidthHeight) {
			let width = document.querySelector("#container-video-" + banner.id)
				.clientWidth;
			let height =
				(width * initialWidthHeight.height) / initialWidthHeight.width;
			return {
				width,
				height
			};
		},
		resizeVideosBlock() {
			this.Block.forEach(banner => {});
		},
		toggleMute(banner) {
			if (banner.playerIndex !== false) {
				this.players[banner.playerIndex].setMute(!banner.isMuted);
				banner.isMuted = !banner.isMuted;
			}
		},
		replay(banner) {
			if (banner.playerIndex !== false && banner.isLoaded) {
				this.players[banner.playerIndex].seek(0).play();
				setTimeout(() => {
					banner.isHovered = false;
				}, 1000);
			}
        }

	},
	created() {
		this.players = [];
	},
	mounted() {
		// Si ya el portal está cargado y se cargaron los videos, cargar los players.
		if (this.isPortalReady && !this.videosLoadedBlock) this.loadBlock();

        window.addEventListener("resize", this.resizeVideosBlock);

	}
};
</script>
